import React, {Component} from 'react';
import Resize from 'react-resize-detector';
import PropTypes from 'prop-types';

import _ from 'lodash';

import './PersonPictograph.css';
import SinglePersonSvg from "./SinglePersonSvg";
import HoverOver from "../HoverOver";

class PersonPictograph extends Component {

  constructor(props) {
    super(props);

    this.state = {
      width: 500
    };
  }

  componentDidMount() {
    this.handelResize(this.refs.wrapper.offsetWidth)
  }

  handelResize(width = 500) {
    this.setState({width: width});
  }

  render() {
    const personCount = this.props.personCount || 10;

    const value = this.props.value || 0;
    const total = this.props.total || 1;
    const totalPercent = value / total;

    const peopleWidth = this.state.width / Math.min(personCount, 10) - 1;

    const people = _.map(_.range(0, personCount), i => {
      const floorPercent = i / personCount;
      const partialPercent = (totalPercent - floorPercent) * personCount;
      const normalizedPartial = Math.min(1, Math.max(0, partialPercent));

      return (
        <SinglePersonSvg
          key={i}
          width={peopleWidth}
          value={normalizedPartial}/>
      )
    });

    const className = this.props.className || '';
    const description = this.props.description || '';
    const label = this.props.label || '';
    const displayCount = `${Number(personCount * totalPercent).toFixed(1)} out of ${personCount}`;
    const displayPercent = `${Number(totalPercent * 100).toFixed(0)}%`;

    return (
      <div ref="wrapper" className={`PersonPictograph ${className}`}
           onMouseEnter={() => {
             const content = (
               <div>
                 <h4>{label}</h4>
                 <div className="spacer"/>
                 <div className="dim-hover">{description}</div>
                 <b>{displayCount} Persons &nbsp;({displayPercent})</b>
               </div>
             );
             const hover = {
               x: this.state.width / 2,
               y: 65,
               content
             };

             this.setState({hover});
           }}
           onMouseLeave={() => {
             this.setState({hover: null});
           }}>
        <Resize handleWidth onResize={this.handelResize.bind(this)}/>
        <h2 className="subtitle">
          {label}{displayCount}
          <small> ({displayPercent})</small>
        </h2>
        <div className="people-wrapper">
          {people}
        </div>
        <HoverOver data={this.state.hover}/>
      </div>
    );
  }
}

PersonPictograph.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.number,
  total: PropTypes.number,
  personCount: PropTypes.number,
  onClick: PropTypes.func
};

export default PersonPictograph;



// WEBPACK FOOTER //
// ./src/charts/PersonPictograph/index.js